import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IUploadFilePayload {
    roomId: string
    data: any
    // {
    //     file: any
    //     msg?: string
    //     description?: string
    //     tmid?: string
    // }
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: [],
    errors: null
}

const uploadFileSlice = createSlice({
    name: 'chat/upload-file',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IUploadFilePayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.messages
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const uploadFileActions = uploadFileSlice.actions
export default uploadFileSlice.reducer
